var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',[_c('div',{staticClass:"text-xs-center"},[_c('div',{staticClass:"headline my-5"},[_vm._v("Loading...")]),_c('v-progress-circular',{attrs:{"size":"100","indeterminate":"","color":"primary"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }